import React, { FC, useMemo } from "react";
import {
  INotification,
  getFirstTimeOptions,
  getTimeLabelsFromMinutes,
  setClass,
} from "@utils";
import { isMobile } from "react-device-detect";
import { Trash } from "../svgs";
import { Select } from "../select2";
import "../../styles/components/notificationTimePopper.scss";
import "../../styles/components/notificationTitle.scss";

interface NotificationTitleProps {
  notification: INotification;
  onChange: (notification: INotification) => void;
  isNew?: boolean;
  onDelete: () => void;
}

export const NotificationTitle: FC<NotificationTitleProps> = ({
  isNew,
  notification: n,
  onDelete,
  onChange,
}) => {
  const timeMessage = useMemo(
    () => getTimeLabelsFromMinutes(n.minutes),
    [n.minutes]
  );

  const onChangeMinutes = (minutes: number) =>
    minutes && onChange({ types: n.types, minutes });
  const renderOption = (option: number) => {
    if (option % 1440 === 0) {
      return (
        <div className="notification-time-label">{`${option / 1440} д.`}</div>
      );
    }
    if (option % 60 === 0) {
      return (
        <div className="notification-time-label">{`${option / 60} ч.`}</div>
      );
    }
    return <div className="notification-time-label">{`${option} мин.`}</div>;
  };

  return (
    <div className="notification-title">
      {n.minutes === -1 && (
        <p className="notification-text">Время ежедневного напоминания 10:00</p>
      )}
      {isNew && (
        <div
          className={setClass("notification-popper-line", isMobile && "mobile")}
        >
          <p className={setClass("notification-text", isMobile && "mobile")}>
            Получать уведомления о предстоящей встрече за
          </p>
          <Select
            classNameRootWrapper="time-select"
            value={n.minutes}
            options={[15, 30, 60, 1440]}
            placeholder="Выберите"
            onChange={onChangeMinutes}
            renderOption={renderOption}
            commonContent
            customOption="За..."
            variant="underlined"
            smallArrow
            customTimeOptions={getFirstTimeOptions(2)}
          />
        </div>
      )}
      {!isNew && n.minutes !== -1 && (
        <>
          <p className={setClass("notification-text", isMobile && "mobile")}>
            {`Получать уведомления о предстоящей встрече за ${timeMessage}`}
          </p>
          <Trash onClick={onDelete} />
        </>
      )}
    </div>
  );
};
